// src/containers/PaymentUrlManage.js
import React, { useState, useEffect } from "react";
import axios from "axios";
import HistoryTable from "../components/HistoryTable";
import {
  Alert,
  IconButton,
  Box,
  useMediaQuery,
  Typography,
  Collapse,
  CircularProgress,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Grid from "@mui/material/Grid2";
import AppBar from "@mui/material/AppBar";
import Navbar from "../components/Navbar";
import Toolbar from "@mui/material/Toolbar";
import { fetchHistory } from "../Service";

const API_URL = process.env.REACT_APP_API_URL;

const History = () => {
  const [history, setHistory] = useState([]);
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  const [message, setMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState(""); // 削除確認ダイアログのステート
  const [appbarHeight, setAppbarHeight] = useState(0);
  const [openAlert, setOpenAlert] = useState(false);
  const [loading, setLoading] = useState(true);

  const [historyData, setHistoryData] = useState([]);
  const [totalCount, setTotalCount] = useState(0);

  useEffect(() => {
    fetchHistoryData(); // コンポーネントがマウントされた時に送金リンクを取得
    const appbarElement = document.getElementById("appbar");
    if (appbarElement) {
      setAppbarHeight(appbarElement.offsetHeight); // Navbarの高さをstateに保存
    }
  }, []);

  useEffect(() => {
    const appbarElement = document.getElementById("appbar");
    if (appbarElement) {
      setAppbarHeight(appbarElement.offsetHeight);
    }
  }, [loading]);

  const fetchHistoryData = async (page = 1, rowsPerPage = 10) => {
    setLoading(true);
    try {
      const data = await fetchHistory(page, rowsPerPage);
      console.log(data);
      setHistoryData(data.records);
      setTotalCount(data.totalCount);
      setLoading(false);
    } catch (error) {
      setErrorMessage("履歴の取得に失敗しました");
      setLoading(false);
      setOpenAlert(true);
      setTimeout(() => setOpenAlert(false), 3000); // 3秒後に非表示
    }
  };

  return (
    <div className="content">
      {loading ? (
        <Box
          sx={{
            position: "fixed", // 画面に固定
            top: "50%", // 垂直方向の中央
            left: "50%", // 水平方向の中央
            transform: "translate(-50%, -50%)", // 自身の中心を基準に中央に配置
            zIndex: 1100, // 他の要素の上に表示（必要に応じて調整）
          }}
        >
          <CircularProgress size={60} color="primary" />
        </Box>
      ) : (
        <>
          <Box
            sx={{
              position: "fixed", // 固定位置にする
              right: 0, // 画面右端に配置
              bottom: 0, // 画面下端に配置
              zIndex: 1300, // AppBarよりも上に表示
              width: "auto", // 幅を自動にする
              maxWidth: "400px", // 幅を制限（必要に応じて調整）
              padding: 2, // 少し余白を加える
            }}
          >
            <Collapse in={openAlert}>
              <Alert
                variant="filled"
                severity="error"
                action={
                  <IconButton
                    aria-label="close"
                    color="inherit"
                    size="small"
                    onClick={() => {
                      setOpenAlert(false);
                    }}
                  >
                    <CloseIcon fontSize="inherit" />
                  </IconButton>
                }
                sx={{ mb: 2 }}
              >
                {errorMessage}
              </Alert>
            </Collapse>
          </Box>

          {isSmallScreen ? (
            <AppBar position="fixed" id="appbar">
              <Toolbar>
                <Navbar />
                <Typography
                  variant="h6"
                  component="div"
                  sx={{ flexGrow: 1, ml: 2 }}
                >
                  ヒストリ
                </Typography>
                {/* <Button color="inherit">Logout</Button> */}
              </Toolbar>
            </AppBar>
          ) : (
            <Navbar />
          )}

          {/* {errorMessage && (
                <Alert
                    severity="error"
                    action={
                        <IconButton
                            color="inherit"
                            onClick={() => setErrorMessage('')}
                        >
                            <CloseIcon />
                        </IconButton>
                    }
                >
                    {errorMessage}
                </Alert>
            )} */}

          {isSmallScreen ? (
            <Grid
              container
              justifyContent="flex-end"
              alignItems="center"
              flexDirection={{ xs: "row", sm: "row" }}
              size={12}
              sx={{ marginTop: `${appbarHeight}px` }}
            >
              {/* <Button variant="contained" color="primary" startIcon={<AddCircleOutlineIcon />} onClick={() => setModalIsOpen(true)}>
                      新しい送金URLを追加
                  </Button> */}
            </Grid>
          ) : (
            <Grid
              container
              justifyContent="space-between"
              alignItems="center"
              flexDirection="row"
              size={12}
            >
              <h2>ヒストリ</h2>
              {/* <Button variant="contained" color="primary" startIcon={<AddCircleOutlineIcon />} onClick={() => setModalIsOpen(true)}>
                      新しい送金URLを追加
                  </Button> */}
            </Grid>
          )}

          <Box className="spacer-lg"></Box>

          <Grid container spacing={2}>
            <HistoryTable
              historyData={historyData}
              setHistoryData={setHistoryData}
              fetchHistoryData={fetchHistory}
              totalCount={totalCount}
              setTotalCount={setTotalCount}
            />
          </Grid>
        </>
      )}
    </div>
  );
};

export default History;
